/**
 * Object that holds event subscribers.
 * @type {Object.<string, Function[]>}
 */
const subscribers = {};

/**
 * Subscribes to an event by adding a callback function to the subscribers list.
 * @param {string} eventName - The name of the event to subscribe to.
 * @param {Function} callback - The callback function to be executed when the event is emitted.
 * @returns {Function} - Function to unsubscribe the callback from the event.
 */
function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

/**
 * @param {string} eventName
 * @returns {void}
 */
function emit(eventName) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback();
        });
    }
}
